'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipns = require('ipns');

var crypto = require('libp2p-crypto');

var PeerId = require('peer-id');

var errCode = require('err-code');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var ipns__namespace = /*#__PURE__*/_interopNamespace(ipns);

var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = Object.assign(debug__default["default"]('ipfs:ipns:republisher'), {
  error: debug__default["default"]('ipfs:ipns:republisher:error')
});
var minute = 60 * 1000;
var hour = 60 * minute;
var defaultBroadcastInterval = 4 * hour;
var defaultRecordLifetime = 24 * hour;

var IpnsRepublisher = /*#__PURE__*/function () {
  function IpnsRepublisher(publisher, datastore, peerId, keychain) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      pass: ''
    };

    _classCallCheck(this, IpnsRepublisher);

    this._publisher = publisher;
    this._datastore = datastore;
    this._peerId = peerId;
    this._keychain = keychain;
    this._options = options;
    this._republishHandle = null;
  }

  _createClass(IpnsRepublisher, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var republishHandle, privKey, pass, firstRun;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this._republishHandle) {
                  _context3.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('republisher is already running'), 'ERR_REPUBLISH_ALREADY_RUNNING');

              case 2:
                republishHandle = {
                  _task: null,
                  _inflightTask: null,
                  _timeoutId: null,
                  runPeriodically: function runPeriodically(period) {
                    republishHandle._timeoutId = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              republishHandle._timeoutId = null;
                              _context.prev = 1;
                              republishHandle._inflightTask = republishHandle._task();
                              _context.next = 5;
                              return republishHandle._inflightTask;

                            case 5:
                              if (republishHandle._task) {
                                republishHandle.runPeriodically(period);
                              }

                              _context.next = 11;
                              break;

                            case 8:
                              _context.prev = 8;
                              _context.t0 = _context["catch"](1);
                              log.error(_context.t0);

                            case 11:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[1, 8]]);
                    })), period());
                  },
                  cancel: function () {
                    var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (republishHandle._timeoutId != null) {
                                clearTimeout(republishHandle._timeoutId);
                              }

                              republishHandle._task = null;
                              _context2.next = 4;
                              return republishHandle._inflightTask;

                            case 4:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    function cancel() {
                      return _cancel.apply(this, arguments);
                    }

                    return cancel;
                  }()
                };
                privKey = this._peerId.privKey;
                pass = this._options.pass;
                firstRun = true;

                republishHandle._task = function () {
                  return _this._republishEntries(privKey, pass);
                };

                republishHandle.runPeriodically(function () {
                  if (firstRun) {
                    firstRun = false;
                    return _this._options.initialBroadcastInterval || minute;
                  }

                  return _this._options.broadcastInterval || defaultBroadcastInterval;
                });
                this._republishHandle = republishHandle;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var republishHandle;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                republishHandle = this._republishHandle;

                if (republishHandle) {
                  _context4.next = 3;
                  break;
                }

                throw errCode__default["default"](new Error('republisher is not running'), 'ERR_REPUBLISH_NOT_RUNNING');

              case 3:
                this._republishHandle = null;
                _context4.next = 6;
                return republishHandle.cancel();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "_republishEntries",
    value: function () {
      var _republishEntries2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(privateKey, pass) {
        var errMsg, keys, _iterator, _step, key, pem, privKey;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this._republishEntry(privateKey);

              case 3:
                _context5.next = 10;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5["catch"](0);
                errMsg = 'cannot republish entry for the node\'s private key';
                log.error(errMsg);
                return _context5.abrupt("return");

              case 10:
                if (!pass) {
                  _context5.next = 45;
                  break;
                }

                _context5.prev = 11;
                _context5.next = 14;
                return this._keychain.listKeys();

              case 14:
                keys = _context5.sent;
                _iterator = _createForOfIteratorHelper(keys);
                _context5.prev = 16;

                _iterator.s();

              case 18:
                if ((_step = _iterator.n()).done) {
                  _context5.next = 32;
                  break;
                }

                key = _step.value;

                if (!(key.name === 'self')) {
                  _context5.next = 22;
                  break;
                }

                return _context5.abrupt("continue", 30);

              case 22:
                _context5.next = 24;
                return this._keychain.exportKey(key.name, pass);

              case 24:
                pem = _context5.sent;
                _context5.next = 27;
                return crypto__default["default"].keys.import(pem, pass);

              case 27:
                privKey = _context5.sent;
                _context5.next = 30;
                return this._republishEntry(privKey);

              case 30:
                _context5.next = 18;
                break;

              case 32:
                _context5.next = 37;
                break;

              case 34:
                _context5.prev = 34;
                _context5.t1 = _context5["catch"](16);

                _iterator.e(_context5.t1);

              case 37:
                _context5.prev = 37;

                _iterator.f();

                return _context5.finish(37);

              case 40:
                _context5.next = 45;
                break;

              case 42:
                _context5.prev = 42;
                _context5.t2 = _context5["catch"](11);
                log.error(_context5.t2);

              case 45:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5], [11, 42], [16, 34, 37, 40]]);
      }));

      function _republishEntries(_x, _x2) {
        return _republishEntries2.apply(this, arguments);
      }

      return _republishEntries;
    }()
  }, {
    key: "_republishEntry",
    value: function () {
      var _republishEntry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(privateKey) {
        var peerId, value;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!privateKey || !privateKey.bytes)) {
                  _context6.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('invalid private key'), 'ERR_INVALID_PRIVATE_KEY');

              case 2:
                _context6.prev = 2;
                _context6.next = 5;
                return PeerId__default["default"].createFromPrivKey(privateKey.bytes);

              case 5:
                peerId = _context6.sent;
                _context6.next = 8;
                return this._getPreviousValue(peerId);

              case 8:
                value = _context6.sent;
                _context6.next = 11;
                return this._publisher.publishWithEOL(privateKey, value, defaultRecordLifetime);

              case 11:
                _context6.next = 18;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](2);

                if (!(_context6.t0.code === 'ERR_NO_ENTRY_FOUND')) {
                  _context6.next = 17;
                  break;
                }

                return _context6.abrupt("return");

              case 17:
                throw _context6.t0;

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 13]]);
      }));

      function _republishEntry(_x3) {
        return _republishEntry2.apply(this, arguments);
      }

      return _republishEntry;
    }()
  }, {
    key: "_getPreviousValue",
    value: function () {
      var _getPreviousValue2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(peerId) {
        var dsVal, record;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (PeerId__default["default"].isPeerId(peerId)) {
                  _context7.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('invalid peer ID'), 'ERR_INVALID_PEER_ID');

              case 2:
                _context7.prev = 2;
                _context7.next = 5;
                return this._datastore.get(ipns__namespace.getLocalKey(peerId.id));

              case 5:
                dsVal = _context7.sent;

                if (dsVal instanceof Uint8Array) {
                  _context7.next = 8;
                  break;
                }

                throw errCode__default["default"](new Error('found ipns record that we couldn\'t process'), 'ERR_INVALID_IPNS_RECORD');

              case 8:
                _context7.prev = 8;
                record = ipns__namespace.unmarshal(dsVal);
                return _context7.abrupt("return", record.value);

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](8);
                log.error(_context7.t0);
                throw errCode__default["default"](new Error('found ipns record that we couldn\'t convert to a value'), 'ERR_INVALID_IPNS_RECORD');

              case 17:
                _context7.next = 24;
                break;

              case 19:
                _context7.prev = 19;
                _context7.t1 = _context7["catch"](2);

                if (!(_context7.t1 && _context7.t1.notFound)) {
                  _context7.next = 23;
                  break;
                }

                throw errCode__default["default"](new Error("no previous entry for record with id: ".concat(peerId.id)), 'ERR_NO_ENTRY_FOUND');

              case 23:
                throw _context7.t1;

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 19], [8, 13]]);
      }));

      function _getPreviousValue(_x4) {
        return _getPreviousValue2.apply(this, arguments);
      }

      return _getPreviousValue;
    }()
  }]);

  return IpnsRepublisher;
}();

exports.IpnsRepublisher = IpnsRepublisher;